// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c9859ef4","703":"92d4f9eb"}[chunkId] + ".chunk.js";
};